import { render } from "./Allocation.vue?vue&type=template&id=ea172dd6"
import script from "./Allocation.vue?vue&type=script&lang=js"
export * from "./Allocation.vue?vue&type=script&lang=js"
script.render = render

export default script